<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.5 32.5H51V7a2 2 0 00-2-2H7a2 2 0 00-2 2v35a2 2 0 002 2h12v4.57a2 2 0 001.06 1.76 2 2 0 00.94.24 2 2 0 001.11-.34L31.45 44H32v8.5a1.5 1.5 0 001.5 1.5h9.15l5.92 4.65a1.52 1.52 0 00.93.32 1.55 1.55 0 00.66-.15 1.48 1.48 0 00.84-1.35V54h6.5a1.5 1.5 0 001.5-1.5V34a1.5 1.5 0 00-1.5-1.5zM30.55 41L22 46.7V41H8V8h40v33zM57 52h-8v4.44L43.35 52H34v-8h15a2 2 0 002-2v-7.5h6z"/></svg>